import { AffectedStaffStatusEnum } from '../../lib/types/enums/affected-staff/affected-staff-status.enum'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type UpdateAffectedStaffStatusInput = {
  status: AffectedStaffStatusEnum
}

export function updateAffectedStaffStatus({
  id,
  ...rest
}: UpdateInput<UpdateAffectedStaffStatusInput>) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.updateStatus.url, { id }))
    .patch(rest)
}
